export class Size {
	width: number;
	height: number;

	constructor(width?: number, height?: number) {
		this.width = width || 0;
		this.height = height || 0;
	}
}
